import {
  Box,
  Heading,
  Img,
  Stack,
  Text,
  UseDisclosureReturn,
} from "@chakra-ui/react";
import { FullModal } from "@ui/components/modal/full/full-modal";
import { TeamCardProps } from "./card";

interface TeamModalProps extends TeamCardProps {
  disclosure: UseDisclosureReturn;
}
export const TeamCardModal = (props: TeamModalProps) => {
  const { image, name, role, blurb } = props;
  return (
    <FullModal
      modal={props.disclosure}
      contentSx={{
        maxH: "90vh",
        maxW: { base: "full", md: "3xl" },
        w: "100%",
        shadow: { md: "base" },
        mx: "auto",
        overflow: "auto",
      }}
    >
      <Box py="12" flex="1">
        <Stack
          direction={{ base: "column-reverse", md: "row" }}
          align="center"
          spacing={{ base: "6", md: "12" }}
          pb="4"
        >
          <Stack
            spacing="0"
            w="full"
            align={{
              base: "center",
              md: "stretch",
            }}
            textAlign={{
              base: "center",
              md: "left",
            }}
          >
            <Heading
              size="xl"
              fontWeight="extrabold"
              letterSpacing="tight"
              fontFamily="numerical"
            >
              {name}
            </Heading>
            <Text
              fontSize="2xl"
              textTransform="uppercase"
              fontFamily="numerical"
            >
              {blurb?.toLowerCase() === "co-founder"
                ? "Co-Founder & " + role
                : role}
            </Text>
          </Stack>
          <Img
            alt={image?.handle}
            src={image?.url}
            w="200px"
            h="200px"
            rounded="full"
            style={{ objectFit: "cover" }}
            htmlHeight={image?.height}
            htmlWidth={image?.width}
            loading="lazy"
            objectPosition="left top"
          />
        </Stack>
        <Stack flex="1" fontSize="lg" w="full" spacing="4">
          {props.bio}
        </Stack>
      </Box>
    </FullModal>
  );
};
